<template>
  <main-layout>

    <!-- 左メニュー -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-50"></menubar>
    </div>

    <!-- ヘッダー行 -->
    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">新規登録</label>
        <sp-smart-button @click="backUsageGuide" slot="cancel">
            {{ $t("button.UsageGuideSetting.backUsageGuide") }}
        </sp-smart-button>

        <narrow-down @click="saveUsageGuide" slot="create" :disabled="disabled">
          {{ $t("button.UsageGuideSetting.saveUsageGuide") }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- メインページ -->
    <div slot="body">
        <div>
            <el-form
                label-position="left"
                :rules="rules"
                :model="query"
                class="submit-form"
                label-width="204px"
                ref="query"
                >
                <el-row class="height-44">

                  <el-form-item
                    :label="$t('label.UsageGuideAdd.Type')"
                    prop="Type"
                    size="small"
                    class="asterisk line-height-55">
                      <div v-if="(this.usageGuideFlag === '04' || this.usageGuideFlag === '01') && outlookFlg">
                        <el-radio  v-model="query.Type" label="04">Outlook施設</el-radio>
                      </div>
                      <div v-if="(this.usageGuideFlag === '03' || this.usageGuideFlag === '01') && !outlookFlg">
                        <el-radio  v-model="query.Type" label="03">施設</el-radio>
                      </div>
                      <div v-if="this.usageGuideFlag === '02' || this.usageGuideFlag === '01' && !outlookFlg">
                        <el-radio style="margin-top: 10px;" v-model="query.Type" label="01">指定席</el-radio>
                      </div>
                        <el-radio style="margin-top:10px" v-model="query.Type" label="02">備品</el-radio>
                  </el-form-item>

                  <el-form-item
                    :label="$t('label.UsageGuideAdd.Name')"
                    prop="Name"
                    size="small"
                    class="asterisk line-height-55">
                    <el-input
                      class="lang-width-input"
                      size="small"
                      v-model="query.Name"
                      maxlength="8"
                    />
                  </el-form-item>

                  <el-form-item
                    v-if="query.Type == '02'"
                    :label="$t('label.UsageGuideAdd.Img')"
                    prop="Portrait"
                    size="small"
                    class="asterisk line-height-55">
                    <upload-image
                        @deleteImage ="deleteImg"
                        @eventImage="changeMapImage($event)">
                    </upload-image>
                  </el-form-item>

                  <el-form-item
                  v-else
                    :label="$t('label.UsageGuideAdd.Color')"
                    prop="color"
                    size="small"
                    class="asterisk line-height-55">
                    <div class ="color">
                        <div class="color1 radio-button-style" @click="selectColor(0)">
                          <img v-show="color == 0" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color2 radio-button-style" @click="selectColor(1)">
                          <img v-show="color == 1" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color3 radio-button-style" @click="selectColor(2)">
                          <img v-show="color == 2" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div  class="color4 radio-button-style" @click="selectColor(3)">
                          <img v-show="color == 3" class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                        <div class="color5 radio-button-style" @click="selectColor(4)">
                          <img v-show="color == 4"  class="selected" src="@/assets/icon/selected.svg" alt=""/>
                        </div>
                    </div>
                  </el-form-item>

                </el-row>
            </el-form>

            <el-dialog-prompt
                :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
                :msgParam="msgParam"
                @on-isPassParam="isPassParam">
            </el-dialog-prompt>

            <loading-dialog :dialogVisible="showLoading" />
            <usageGuidePopup :isShowPopup.sync="showPopup"></usageGuidePopup>
        </div>
    </div>
    <!--  メインページ 終了  -->
  </main-layout>
</template>

<script>
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import NewDesignLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import Menubar from "@/components/leftmenu/DashBoard";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import errorCodeMsg from "@/utils/error-code-msg"
import SpSmartButton from "@/components/common/sp-smart-button"
import UploadImage from "@/components/common/sp-smart-upload/index"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import usageGuidePopup from "@/components/system/popup/UsageGuidePopup";
const colorList = ["#8C251C","#73226C","#291F99","#198022","#758006"]

export default {
  name: "UsageGuideAdd",
  computed: {
    Type() {
    return this.query.Type
  }
  },
  components: {
    UploadImage:UploadImage,
    SpSmartButton:SpSmartButton,
    MainLayout: NewDesignLayout,
    Menubar: Menubar,
    headTitle: headTitle,
    narrowDown,
    elDialogPrompt,
    LoadingDialog,
    usageGuidePopup
  },
  data() {
    return {
        rules:{
            Name:[
                {
                    required: true,
                    trigger:'change',
                    message: this.$t("message.common.validation.required", {
                        field: this.$t("label.UsageGuideAdd.Name"),
                    })
                }
            ],
            Portrait:[
                {
                    required: true,
                    trigger:'change',
                    message: this.$t("message.common.validation.required", {
                        field: "画像",
                    })
                }
            ],
        },
        disabled: true,
        showPopup: false,
        showLoading:false,
        centerDialogVisibleIsShow:false,
        msgParam:"該当エリア凡例を作成してもよろしいでしょうか？",
        color:0,
        usageGuideId:null,
        fixDeskLength:0,
        imgLength:0,
        query:{
            buildId:null,
            ExId:null,
            Name:null,
            Type:"03",
            Color:colorList[0],
            Portrait:null,
        },
        usageGuideFlag : null,
        outlookFlg: false
    };
  },
  watch: {
      Type() {
          this.$refs['query'].clearValidate();
      },
      query:{
        handler: function (val) {
          let disable = false
          if(val.Name == null || val.Name == ""){
            disable = true
          }
          if(val.Type == '01' && val.Color == null){
            disable = true
          }
          if(val.Type == '02' && val.Portrait == null){
            disable = true
          }
          if(val.Type == '03' && val.Color == null){
            disable = true
          }
          this.disabled = disable;
        },
        deep: true
      },
  },
  methods: {
      deleteImg(){
        this.query.Portrait = null
      },
      changeMapImage(data) {
        for(var i = 0; i < data.length; i++){
            this.query.Portrait = data[i].raw
        }
      },
      selectColor(index){
        this.color = index
        this.query.Color = colorList[index]
      },
      backUsageGuide(){
        this.$router.push({
            name: "system-UsageGuideSetting",
            query:{
              usageGuideFlag : this.usageGuideFlag,
              outlookFlg : this.outlookFlg,
            }
        });
      },
      saveUsageGuide(){
        if(this.query.Type == '01' && this.fixDeskLength >= 5){
          this.showPopup = true
        }else if(this.query.Type == '02' && this.imgLength >= 5){
          this.showPopup = true
        }else if(this.query.Type == '03' && this.meetingRoomLenth >= 5){
          this.showPopup = true
        }else if(this.query.Type == '04' && this.outlookMeetingRoomLenth >= 5){
          this.showPopup = true
        }else{
            this.$refs["query"].validate((valid) => {
              if(valid){
                  this.centerDialogVisibleIsShow = true;
              }
            })
        }
      },
      isPassParam(){
        this.showLoading = true
        this.doneSaveUsageGuide();
      },
      doneSaveUsageGuide(){

        SystemManageApi.SaveUsageGuide({
            BuildId:this.query.buildId,
            ExId:this.query.ExId,
            Name:this.query.Name,
            Type:this.query.Type,
            color:this.query.Color,
            Portrait: this.query.Portrait
        })
          .catch((error) => {
              this.showLoading = false
            errorCodeMsg(error, this)
          })
          .then(({data}) => {
            this.showLoading = false
            let errormsg = null;
            if(data.errorMessage != null){
              if(data.errorMessage.indexOf("カラー") != -1){
                 errormsg = "usageColor"
              }else{
                errormsg = "Max_Length_Error"
              }
            }
            if (!statusErrorCodeMsg(data.statusCode, this, errormsg)) {
                return;
            }
            this.usageGuideId = data.body
            this.done();
          })
          .catch((error) => {
            error;
          })
          .finally(() => {
          });
      },
      done() {
        this.$messageIotSuccess(this.$t('message.common.createSuccess',{
            field: '該当エリア凡例'
        }))
        this.$savePageInfo("system","UsageGuideSetting","M-06-49","ugId",this.usageGuideId)
/*         this.$router.push({
            name: "system-UsageGuideDetail"
        }); */
        this.$router.push({
            name: "system-UsageGuideSetting",
            query:{
              usageGuideFlag : this.usageGuideFlag,
              outlookFlg : this.outlookFlg,
            }
        });
      },
  },
  mounted() {
      this.query.buildId = this.$getPageInfo("system", "build", "M-06-49", "buildingId");
      this.meetingRoomLenth =  this.$getPageInfo("system", "build", "M-06-49", "meetingRoomLenth")
      this.outlookMeetingRoomLenth =  this.$getPageInfo("system", "build", "M-06-49", "outlookMeetingRoomLenth")
      this.fixDeskLength =  this.$getPageInfo("system", "build", "M-06-49", "fixDeskLenth")
      this.imgLength = this.$getPageInfo("system", "build", "M-06-49", "imgLength")
  },
  created() {
    this.$authCheck("010902")
    let breadcrumb = [
      {
          path: "/",
          title: "label.router.home",
      },
      {
          path: "/system/setting/various",
          title: "label.router.set",
      },
      {
          path: "",
          title: "label.router.comprehensive",
      },
      {
          path: "/system/buildings/search",
          title: "label.router.building",
      },
      {
        path: "",
        title: "label.router.detailBuilding",
      },
      {
          path: "/system/UsageGuideSetting",
          title: "label.router.UsageGuideSetting",
      },
      {
          path: "",
          title: "label.router.UsageGuideAdd",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    this.usageGuideFlag = this.$route.query.usageGuideFlag;
    this.outlookFlg = this.$route.query.outlookFlg;

    if(this.usageGuideFlag == "01") {
      if(this.outlookFlg){
        this.query.Type = "04";
      } else {
        this.query.Type = "03";
      }
      this.query.Color = colorList[0];
    }else if (this.usageGuideFlag == "03"){
      this.query.Type = "03";
      this.query.Color = colorList[0];
    }else if (this.usageGuideFlag == "02"){
      this.query.Type = "01";
      this.query.Color = colorList[0];
    }else if (this.usageGuideFlag == "04"){
      this.query.Type = "04";
      this.query.Color = colorList[0];
    }
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-form-item__label {
        text-align: justify;
    }
::v-deep .asterisk {
  .el-form-item__label::before{
    display: none;
  }
}
::v-deep .asterisk {
  .el-form-item__label::after{
    content: "※";
    color: #E65245;
    margin-right: 4px;
    font-size: 50%;
    vertical-align: 8%;
  }
}
::v-deep .el-form-item {
  margin-bottom: 40px !important;
}
.line-height-44::v-deep {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
::v-deep .el-form-item__content{
    margin-top: 10px;
}
.line-height-55::v-deep {
  .el-form-item__label {
    line-height: 55px !important;
  }
.class-a{
      border: 0px solid !important;
  }
  .color{
      width: 220px;
      margin-top: 5px !important;
  }
  .selected{
    margin-left: 5px;
  }
  .color1{
      box-shadow:2px 2px 5px rgb(196, 194, 194);
      color: #ffffff;
      border-radius: 50%;
      border: 0px solid;
      margin-right: 20px;
      width: 26px;
      height: 26px;
      float: left;
      background-color:#8C251C;
  }
  .color2{
          box-shadow:2px 2px 5px rgb(196, 194, 194);
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      width: 26px;
      height: 26px;
      float: left;
      background-color:#73226C;
  }
  .color3{
          box-shadow:2px 2px 5px rgb(196, 194, 194);
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#291F99;
  }
  .color4{
          box-shadow:2px 2px 5px rgb(196, 194, 194);
      border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      margin-right: 20px;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#198022;
  }
  .color5{
          box-shadow:2px 2px 5px rgb(196, 194, 194);
          border-radius: 50%;
      color: #ffffff;
      border: 0px solid;
      float: left;
      width: 26px;
      height: 26px;
      background-color:#758006;
  }
}
::v-deep .cancel-width{
  .my-button{
    width: 152px;
    height: 32px;
  }
}

::v-deep .el-radio__label{
  padding-left: 28px;
  font-size:16px
}

::v-deep .el-dialog__body{
  color: #525250;
}

.radio-button-style {
  cursor: pointer;
}

.radio-button-style:hover {
  opacity: 0.8;
}
</style>
